import { Injectable } from '@angular/core';

/**
 * A service to handle full page reloads.
 * This is useful for clearing application state and re-initializing the entire app.
 */
@Injectable({
  providedIn: 'root'
})
export class RefreshService {

  constructor() { }

  /**
   * Forces the browser to perform a full page reload.
   */
  public triggerPageRefresh(): void {
    window.location.reload();
  }
}
